import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = { class: "gap-4 sm:grid-cols-2 md:grid lg:grid-cols-3" }
const _hoisted_6 = { class: "mb-1 font-semibold" }
const _hoisted_7 = { class: "mb-1 font-semibold" }
const _hoisted_8 = { class: "mb-1 font-semibold" }
const _hoisted_9 = { class: "sm:col-span-2 lg:col-span-3" }
const _hoisted_10 = { class: "mb-1 font-semibold" }
const _hoisted_11 = { class: "space-x-2 text-xs text-gray-500" }

import { ref, Ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { useUiStore } from '@/stores';
import ScheduleService from '@/services/api/ScheduleService';
import { toastServiceError } from '@/services/core/notification';

import { Permission, ScheduleModel, ScheduleWeekday } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleDetailPage',
  setup(__props) {

const route = useRoute();
const uiStore = useUiStore();
const { t } = useI18n();

const schedule: Ref<ScheduleModel | undefined> = ref(undefined);

const weekdays: ScheduleWeekday[] = [
    ScheduleWeekday.SUNDAY,
    ScheduleWeekday.MONDAY,
    ScheduleWeekday.TUESDAY,
    ScheduleWeekday.WEDNESDAY,
    ScheduleWeekday.THURSDAY,
    ScheduleWeekday.FRIDAY,
    ScheduleWeekday.SATURDAY,
];

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const fetchScheduleById = async (id: number) => {
    try {
        setLoading(true);
        const { data } = await ScheduleService.get<ScheduleModel>(id);
        schedule.value = data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

const activeDays = computed(() => weekdays.filter((day: ScheduleWeekday) => schedule.value?.[day]));

const formatDayLabel = (day: ScheduleWeekday) => t('schedule.labels.' + day.toLowerCase());

onMounted(() => {
    const id = Number(route.params.id);
    if (!isNaN(id)) fetchScheduleById(id);
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiAuditStatusInfo = _resolveComponent("UiAuditStatusInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('schedule.view.title')), 1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListSchedule' } }),
          (_ctx.$can(_unref(Permission).EDIT_SCHEDULE))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: {
                            name: 'EditScheduleById',
                            params: {
                                id: _unref(route).params.id,
                            },
                        },
                class: "block hover:bg-gray-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "primary",
                    "text-variant": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_UiPanel, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('schedule.labels.name')), 1),
              _createElementVNode("p", null, _toDisplayString(schedule.value?.name), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('schedule.labels.timeBegin')), 1),
              _createElementVNode("p", null, _toDisplayString(schedule.value?.timeBegin.substring(0, 5)), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('schedule.labels.timeEnd')), 1),
              _createElementVNode("p", null, _toDisplayString(schedule.value?.timeEnd.substring(0, 5)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t('schedule.labels.daysActive')), 1),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeDays.value, (day) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: day,
                    class: "rounded border bg-white px-1.5 py-0.5"
                  }, _toDisplayString(formatDayLabel(day)), 1))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_UiAuditStatusInfo, {
            "model-value": schedule.value,
            class: "bt-1 mt-4 border-t border-gray-300 pt-2"
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})